import ApplicationRecord from './ApplicationRecord';
export default class Organization
  extends ApplicationRecord({
    /**
   * @type {String}
   */
    id: '#Organization',
    name: '',
    legalName: '',
    addressLocality: '',
    postalCode: '',
    streetAddress: '',
    addressRegion: '',
    addressCountry: '',
  }) {}



// WEBPACK FOOTER //
// ./src/models/Organization.js